import React, { Component } from 'react';
import firebase from 'firebase';
import logo from './logo.svg';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      phoneNumber: '',
      message: ''
    };

    var config = {
      apiKey: "AIzaSyArtv1itVJHSEAR6f0B3xCHQQV1PJlJz1Q",
      authDomain: "oynio-website.firebaseapp.com",
      databaseURL: "https://oynio-website.firebaseio.com",
      projectId: "oynio-website",
      storageBucket: "oynio-website.appspot.com",
      messagingSenderId: "443194241367"
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    firebase.initializeApp(config);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });

    console.log(this.state);
  }

  handleSubmit(event) {
    //alert('A name was submitted: ' + JSON.stringify(this.state));
    event.preventDefault();

    let dbCon = firebase.database().ref('/messages');
    dbCon.push({
      message: this.state
    });
  }

  render() {
    return (
      <div class="mail" id="mail">
      <div class="container">
        <div class="agileits-title">
          <h3>Mail Us</h3>
        </div> 
        <div class="w3_mail_grids">
          <form  onSubmit={this.handleSubmit}>
            <span class="input input--jiro">
              <input class="input__field input__field--jiro" type="text" id="input-10" name="name" placeholder="Your Name" required=""  value={this.state.name} onChange={this.handleInputChange} />
              <label class="input__label input__label--jiro" for="input-10">
                <span class="input__label-content input__label-content--jiro">Your Name</span>
              </label>
            </span>
            <span class="input input--jiro">
              <input class="input__field input__field--jiro" type="email" id="input-11" name="email" placeholder="Your Email Address" required=""  value={this.state.email}  onChange={this.handleInputChange}  />
              <label class="input__label input__label--jiro" for="input-11">
                <span class="input__label-content input__label-content--jiro">Your Email</span>
              </label>
            </span>
            <span class="input input--jiro">
              <input class="input__field input__field--jiro" type="text" id="input-12" name="phoneNumber" placeholder="Phone Number" required=""  value={this.state.phoneNumber}  onChange={this.handleInputChange}  />
              <label class="input__label input__label--jiro" for="input-12">
                <span class="input__label-content input__label-content--jiro">Phone Number</span>
              </label>
            </span>
            <textarea name="message" placeholder="Message..." required=""  value={this.state.message}  onChange={this.handleInputChange}  />
            <input type="submit" value="Submit" />
          </form>
        </div>
      </div>
    </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js